'use strict';

wbApp.controller('CoursesStudentsDetailCtrl', ['$scope', '$modal', 'securitySvc', 'messageBoxSvc', 'courseRegistrationSvc', 'tenantSettingSvc', 'leadSvc',
    '$translate', 'courseSvc', '$filter', 'localStorageService',
function ($scope, $modal, securitySvc, messageBoxSvc, courseRegistrationSvc, tenantSettingSvc, leadSvc, $translate, courseSvc, $filter, localStorageService) {

    $scope.allowDiscounts = tenantSettingSvc.settings.allowDiscounts;
    $scope.calculatedDueDate = { dueDate: null };
    $scope.modelOrig = angular.copy($scope.model);
    $scope.registeredAttendance = [];

    $scope.isReady = false;
    $scope.isBusy = false;

    $scope.popover = {
        fromDate: null,
        toDate: null,
        okClick: function () {
            var fromDateM = moment($scope.popover.fromDate).startOf('day');
            var toDateM = moment($scope.popover.toDate).endOf('day');

            angular.forEach($scope.registeredAttendance, function (key, value) {
                var lessonStartDate = moment(key.startDate);
                if (fromDateM.isSameOrBefore(lessonStartDate) &&
                    toDateM.isSameOrAfter(lessonStartDate)) {
                    // in range
                    if (!key.isDisabled) {
                        key.isRegistered = true;
                    }
                } else {
                    // out of range
                    if (!key.isDisabled) {
                        key.isRegistered = false;
                    }
                }
            });            
        }
    }
    
    $scope.onRegistrationDateChange = function(registrationDate) {
        if ($scope.allowDiscounts) {
            courseRegistrationSvc.calcExpectedDueDate($scope.course.courseID, registrationDate).$promise.then( function(data) {
                $scope.calculatedDueDate.dueDate = data.dueDate;
            });
        } 
    }

    function extendModel(course) {

        setIsBusy(true);

        courseRegistrationSvc.initializeModel($scope.model, course, false, true)
        .then(function () {
            $scope.modelOrig = angular.copy($scope.model);
            $scope.registeredAttendance = $scope.model.registeredAttendance;

            if ($scope.allowDiscounts) {
                courseRegistrationSvc.calcExpectedDueDate($scope.course.courseID, $scope.model.registrationDate).$promise.then( function(data) {
                    $scope.calculatedDueDate.dueDate = data.dueDate;
                });
            }

            setIsBusy(false);
        },
        function (errorResult) {
            $scope.registeredAttendance = [];
            $scope.detailError = errorResult;

            setIsBusy(false);
        });
    }

    function setIsBusy(isBusy) {
        $scope.isBusy = isBusy;
        $scope.isReady = !isBusy;
        angular.forEach($scope.detailTabs, function (tab) {
            tab.disabled = isBusy;
        });
    }


    extendModel($scope.course);

    $scope.onStudentChange = function (studentID) {
        extendModel($scope.course);
    }

    $scope.isSaving = false;

    $scope.onDataRangeChanged = function () {

    }

    $scope.onDetailCanceled = function () {
        $scope.$hide();
        if ($scope.onAfterDialogCancel) {
            $scope.onAfterDialogCancel();
        }        
    }

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function saveLead(cr) {
            if (!!selectedLead) {
                if (securitySvc.isInRole('Leads') && securitySvc.isInRole('Leads.Update')) {

                    selectedLead.conversionType = 1; // CourseRegistraction
                    selectedLead.conversionReferenceId = cr.courseRegistrationID;
                    selectedLead.conversionDateUtc = moment().toDate();

                    var courseFullName = courseSvc.getCourseFullName($scope.course);
                    var firstLesson = !!$scope.course.firstLesson
                        ? ' (' + $filter('date')($scope.course.firstLesson, 'EEE HH:mm').toUpperCase() + ')'
                        : '';
                    selectedLead.conversionText = courseFullName + firstLesson;
                    selectedLead.status = 1; // Converted

                    if (!selectedLead.notes || selectedLead.notes.length == 0) {
                        selectedLead.notes = [];
                    }

                    var user = securitySvc.loggedInUser();

                    selectedLead.notes.push({
                        text: $translate.instant('TXT_TITLE_REGISTER_ON_COURSE') + ': ' + selectedLead.conversionText,
                        updatedAtUtc: moment().toDate(),
                        updatedByUserId: user.userID + "",
                        updatedByName: user.fullName
                    });

                    leadSvc.update(selectedLead);
                }
            }
        }

        function success(cr) {
            saveLead(cr);
            $scope.onAfterSuccessSave(cr);
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        function cancel() {
            $scope.isSaving = false;
        }

        var selectedLead = null;

        function confirmUpdate(updateInvoice) {
            messageBoxSvc.showConfirmClientNotification({
                userSetting: ['confimNotificationCourseStudent'],
                showSendSmsNotification: false,
                callback: function (notificationConfig) {
                    courseRegistrationSvc.update(
                        model,
                        notificationConfig,
                        1, /* SubjectCategory.RegularCourses */
                        updateInvoice,
                        success,
                        error);
                }
            });
        }

        if (!$scope.ignoreLeadAssignment && // Do not search for leads during course registration save
            !model.courseRegistrationID &&
            securitySvc.isInRole('Leads') &&
            securitySvc.isInRole('Leads.Update')) {
            leadSvc.getAllByStatusAndStudent(0, model.studentID).$promise.then(function (leads) {
                if (!!leads && leads.length != 0) {
                    // Leads selection dialog
                    leadSelectionDlg.$promise.then(function () {
                        leadSelectionDlg.$scope.leads = leads;
                        leadSelectionDlg.$scope.onLeadSelected = function (lead) {
                            selectedLead = lead;
                            saveImpl();
                        };
                        leadSelectionDlg.show();
                    });
                } else {
                    selectedLead = null;
                    saveImpl();
                }
            });
        } else {
            saveImpl();
        }

        function saveImpl()
        {
            $scope.saveManualAdjustmentTextToLocalStorage(model.invoice);

            if (!model.courseRegistrationID) {
                messageBoxSvc.showConfirmClientNotification({
                    userSetting: ['confimNotificationCourseStudent'],
                    showSendSmsNotification: false,
                    callback: function (notificationConfig) {
                        courseRegistrationSvc.insert(
                            model,
                            notificationConfig,
                            1, /* SubjectCategory.RegularCourses */
                            success,
                            error);
                    }
                });
            } else {
                if (model.invoice.isModified) {
                    // Invoice has changed, ask user for confirmation
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRMATION',
                        message: 'TXT_TEXT_INVOICE_HAS_CHANGED',
                        buttons: [{
                            text: 'TXT_BTN_CANCEL',
                            callback: cancel
                        }, {
                            text: 'TXT_BTN_NO_INVOICE_CHANGES',
                            callback: function () { confirmUpdate(false); }
                        }, {
                            text: 'TXT_BTN_CREATE_NEW_INVOICE',
                            callback: function () { confirmUpdate(true); }
                        }]
                    });
                } else {
                    courseRegistrationSvc.update(
                        model,
                        {
                            sendEmailNotification: false,
                            sendSmsNotification: false
                        },
                        1, /* SubjectCategory.RegularCourses */
                        false,
                        success,
                        error);
                }
            }
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig) && !!$scope.modelOrig.courseRegistrationID &&
            (!!$scope.model.invoice && !$scope.model.invoice.isModified);
    };

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: 'courses/courses/courses-detail-tabs/students-detail-main-tab.html',
        disabled: true,
    }, {
        title: 'TXT_SEC_COMPENSATION_SUMMARY',
        template: 'courses/courses/courses-detail-tabs/students-detail-compensations-tab.html',
        disabled: true,
    }, {
        title: 'TXT_LBL_ATTENDANCE',
        template: 'courses/courses/courses-detail-tabs/students-detail-attendance-tab.html',
        disabled: true,
    }, {
        title: 'TXT_PRICE_TAB',
        template: 'courses/courses/courses-detail-tabs/students-detail-price-tab.html',
        disabled: true,
    }, {
        title: 'TXT_LAB_HEALTH',
        template: 'courses/courses/courses-detail-tabs/students-detail-health-tab.html',
        disabled: true,
    }, {
        title: 'TXT_LBL_PARENT',
        template: 'courses/courses/courses-detail-tabs/students-detail-parent-tab.html',
        disabled: true,
    }];

    if (!securitySvc.isInRole('CourseRegistration.Compensations')) {
        $scope.detailTabs.splice(1, 1);
    }

    $scope.detailTabs.activeTab = 0;


    $scope.attendanceFilterOptions = {
        filterText: ""
    };

    $scope.attendanceGridOptions = {
        sortInfo: { fields: ['startDate'], directions: ['asc'] },
        columnDefs: [{ field: 'startDate', displayName: "TXT_LBL_START_DATE", cellFilter: 'date:dd.MM.yy EEE HH:mm', width: '130px' },
                     { field: 'endDate', displayName: "TXT_LBL_END_DATE", cellFilter: 'date:HH:mm', width: '60px' },
                     { field: 'courseAttendanceType', displayName: "TXT_COL_ATTENDANCE_TYPE", cellFilter: 'attendanceType', width: '110px' },
                     { field: 'courseAttendanceStatus', displayName: "TXT_COL_ATTENDANCE_STATUS", cellFilter: 'attendanceStatus', width: '110px' },
                     { field: 'attendanceNotes', displayName: "TXT_NOTE" }
        ],
        noCommandColumn: true,
        multiSelect: true,
        selectedField: 'isRegistered',
        disabledField: 'isDisabled',
        pageSize: 50
    };

    var amortizationScheduleDlg = $modal({
        templateUrl: 'courses/courses/courses-detail-tabs/students-amortization-schedule.html',
        show: false,
        backdrop: true,
        scope: $scope.$new()
    });

    var leadSelectionDlg = $modal({
        templateUrl: 'leads/leads/lead-select-open-leads-dialog.html',
        show: false,
        backdrop: true,
        scope: $scope.$new()
    });


    $scope.showAmortizationSchedule = function (studentRegistration) {
        amortizationScheduleDlg.$promise.then(function () {
            amortizationScheduleDlg.$scope.model = studentRegistration;
            amortizationScheduleDlg.$scope.amortizationScheduleTemplates = studentRegistration.invoice.course.amortizationSchedules;
            amortizationScheduleDlg.show();
        });
    }

    $scope.saveManualAdjustmentTextToLocalStorage = function (invoice) {
        if (localStorageService.isSupported) {
            var manualAdjustmentLine = _.find(invoice.lines, function (line) {
                return line.lineType == "ManualAdjustment" && line.runtimeManualAdjustmentType == 1;
            });

            if (!!manualAdjustmentLine) {
                localStorageService.set('manualAdjustmentDiscountLineName', manualAdjustmentLine.name);
                localStorageService.set('manualAdjustmentDiscountLinePercent', manualAdjustmentLine.percent);
            }
        }
    }

    $scope.addInvoiceLine = function (manualAdjustmentLineType) {
        var newLine = $scope.model.invoice.addManualAdjustmentLine(manualAdjustmentLineType);
        if (manualAdjustmentLineType == 1) {

            if (localStorageService.isSupported) {
                newLine.name = localStorageService.get('manualAdjustmentDiscountLineName') || $translate.instant('TXT_DISCOUNT');
                newLine.percent = localStorageService.get('manualAdjustmentDiscountLinePercent') || 0;
            } else {
                newLine.name = $translate.instant('TXT_DISCOUNT');
            }
        }
    }

    $scope.removeInvoiceLine = function (invoice, index) {
        invoice.removeManualAdjustmentLine(index);
    }

    $scope.addManualAdjustmentLineDropdown = [
        {
            text: $translate.instant('TXT_ADD_LINE_DISCOUNT_IN_PERCENT'),
            click: 'addInvoiceLine(1)'
        },
        {
            text: $translate.instant('TXT_ADD_LINE_EMPTY'),
            click: 'addInvoiceLine(0)'
        }
    ];


}]);
